var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.5 29.3",
    enableBackground: "new 0 0 28.5 29.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4BB543",
    d: "M13.5,28.7c-0.1,0-0.1,0-0.2,0c-7.1-0.1-12.8-6-12.7-13.1C0.7,8.5,6.5,2.8,13.5,2.8c0.1,0,0.1,0,0.2,0 c2,0,3.9,0.5,5.7,1.4c0.5,0.3,0.7,0.9,0.4,1.3C19.6,6.1,19,6.3,18.5,6c-1.5-0.8-3.1-1.2-4.8-1.2c-6-0.1-11,4.7-11.1,10.7 c-0.1,6,4.7,11,10.7,11.1c0.1,0,0.1,0,0.2,0c5.9,0,10.8-4.8,10.9-10.7c0-1.6-0.3-3.1-0.9-4.5c-0.2-0.5,0-1.1,0.5-1.3 c0.5-0.2,1.1,0,1.3,0.5c0.7,1.7,1.1,3.5,1.1,5.4C26.3,23,20.6,28.7,13.5,28.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4BB543",
    d: "M13.5,20.5c-0.3,0-0.6-0.1-0.8-0.3l-6-6.8c-0.4-0.4-0.3-1,0.1-1.4c0.4-0.4,1-0.3,1.4,0.1l5.2,5.9l13-17.2 c0.3-0.4,1-0.5,1.4-0.2c0.4,0.3,0.5,1,0.2,1.4L14.3,20.2C14.1,20.4,13.9,20.5,13.5,20.5C13.5,20.5,13.5,20.5,13.5,20.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmGreen);
export default __webpack_public_path__ + "static/media/_confirmGreen.eb35e73b6f642817a5b07aaf151e4094.svg";
export { ForwardRef as ReactComponent };